import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnquiryFeaturesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EnquiryFeaturesQuery = { __typename?: 'Query', enquiryFeatures: { __typename?: 'OmsEnquiryFeaturesType', finishes: Array<{ __typename?: 'Finish', defaultColorId?: string | null, id: string, isCustom: boolean, name: string, processId: string, restrictedMaterials: Array<number>, colors?: Array<{ __typename?: 'Color', id: string, name: string }> | null }>, materialTypes: Array<{ __typename?: 'MaterialType', defaultFinishId?: string | null, defaultMaterialId?: string | null, id: string, isCustom: boolean, name: string, processId: string }>, processes: Array<{ __typename?: 'OmsEnquiryProcessType', defaultColorId?: string | null, id: number, nameEn?: string | null, colors: Array<{ __typename?: 'Color', id: string, name: string }> }> } };


export const EnquiryFeaturesDocument = gql`
    query enquiryFeatures {
  enquiryFeatures {
    finishes {
      colors {
        id
        name
      }
      defaultColorId
      id
      isCustom
      name
      processId
      restrictedMaterials
    }
    materialTypes {
      defaultFinishId
      defaultMaterialId
      id
      isCustom
      name
      processId
    }
    processes {
      colors {
        id
        name
      }
      defaultColorId
      id
      nameEn
    }
  }
}
    `;

/**
 * __useEnquiryFeaturesQuery__
 *
 * To run a query within a React component, call `useEnquiryFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnquiryFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnquiryFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnquiryFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>(EnquiryFeaturesDocument, options);
      }
export function useEnquiryFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>(EnquiryFeaturesDocument, options);
        }
export function useEnquiryFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>(EnquiryFeaturesDocument, options);
        }
export type EnquiryFeaturesQueryHookResult = ReturnType<typeof useEnquiryFeaturesQuery>;
export type EnquiryFeaturesLazyQueryHookResult = ReturnType<typeof useEnquiryFeaturesLazyQuery>;
export type EnquiryFeaturesSuspenseQueryHookResult = ReturnType<typeof useEnquiryFeaturesSuspenseQuery>;
export type EnquiryFeaturesQueryResult = Apollo.QueryResult<EnquiryFeaturesQuery, EnquiryFeaturesQueryVariables>;